import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TranslationService } from '../services/translation.service';
import { Subscription } from 'rxjs';

@Pipe({ name: 'translate', pure: false })
export class TranslatePipe implements PipeTransform, OnDestroy {
  private lastKey: string;
  private lastValue: string;
  private sub: Subscription;

  constructor(private translationService: TranslationService, private ref: ChangeDetectorRef) {
    this.sub = this.translationService.langChange.subscribe(() => {
      this.lastValue = null;
      this.ref.markForCheck();
    });
  }

  transform(value: string, params: any = {}): string {
    if (!value) {
      return value;
    }

    // Create a unique cache key that includes both the translation key and any parameters
    const cacheKey = value + JSON.stringify(params);
    
    // Get translation with parameters
    const translated = this.translationService.translate(value, params);
    
    // Only cache if we got a real translation (not the key itself)
    if (translated !== value) {
      this.lastKey = cacheKey;
      this.lastValue = translated;
      return translated;
    }
    
    // If translation not found and we have a cached value, return cached
    if (cacheKey === this.lastKey && this.lastValue && this.lastValue !== value) {
      return this.lastValue;
    }
    
    // Return the translated value (might be the key if not found)
    return translated;
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
